<template>
  <div class="lines" ref="place_ref"></div>
</template>

<script>
//引入常量对象
import CONSTANCE from "@/static/js/constance";
import api from "@/services/api";
export default {
  props: {
    echartsList: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      mychart: null,
      tableData: {
      },
      ojectList: {
        1:"正面情绪",
        2:"负面情绪",
        3:"不确定"
      },
    };
  },
  watch: {
    echartsList() {
      this.tableData = {};
      this.tableData = this.echartsList;
      // console.log(this.echartsList,"传过来的");
      this.updateData();
    },
  },
  mounted() {
    // console.log(this.echartsList,"echartsList");
    // console.log(this.$store.getters.getRegionMap[this.mapName],"this.$store.getters.getRegionMap[this.mapName]");
    if(this.echartsList){ // 放大的框框调用第一条
     this.tableData = this.echartsList;
     this.initchart()
     this.updateData()
    }else{
      this.getData();
      this.initchart();
    }
    
  },
  methods: {
    initchart() {
      this.mychart = this.echarts.init(this.$refs.place_ref);
    },
    updateData() {
      const xData = this.tableData.key; //1,2,3
      const yData1 = this.tableData.value.map((item) => Object.values(item)[0]);
      const yData2 = this.tableData.value.map((item) => Object.values(item)[1]);
      const yData3 = this.tableData.value.map((item) => Object.values(item)[2]);
      const name = this.tableData.value.map((item) => Object.keys(item))[0]
      const newName = name?.map((item) => this.ojectList[item]);
      const yData = [[...yData1], [...yData2], [...yData3]]
      const kind = this.tableData.chart;
      // const name = this.tableData.name.map((item) => this.ojectList[item]);
      // console.log(xData,yData,kind,name);
      var color = [
        "#2ca1ff",
        "#0adbfa",
        "#febe13",
        "#65e5dd",
        "#7b2cff",
        "#fd5151",
        "#f071ff",
        "#85f67a",
        "#5ce0e2",
      ];
      const series = [];
      for (var i = 0; i < yData.length; i++) {
        series.push({
          type: "bar",
          barWidth:5,
          data: yData[i],
          name: newName[i],
          itemStyle: {
            normal: {
              borderWidth: 2,
              shadowBlur: 5,
              // borderRadius: 15,
              borderColor: color[i],
              shadowColor: color[i],
            },
          },
          lineStyle: {
            width: 5,
            color: color[i], //线颜色
            shadowColor: color[i], //点颜色
            shadowBlur: 20,
          },
        });
      }
      const option = {
        title: {
        //   text: "情绪分析",
        //   textStyle: {
        //     color: "#9DCFCF",
        //   },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              show: true,
              backgroundColor: "#fff",
              color: "red",
              borderColor: "rgba(0,0,0,0)",
              shadowColor: "rgba(0,0,0,0)",
              shadowOffsetY: 0,
            },
            lineStyle: {
              width: 0,
            },
          },
        },
        legend: {
          data: newName,
            textStyle: {
            color: "#7ec7ff",
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
            magicType: {
              type: kind,
            },
          },
        },
        xAxis: {
          name:'月',
          type: "category",
          boundaryGap: false,
          data: xData,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#9DCFCF", //这里用参数代替了
            },
            interval: 0,
            rotate: 28,//倾斜度
          },
           
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          scale: true, //自动根据数据来调整y轴区间
        },
        dataZoom: [
          {
            type: "inside",
          },
          {
            type: "slider", //滑动条
            showDetail: true,
            // xAxisIndex:0,
            // yAxisIndex:0,
            textStyle: {
              //文本样式
              color: CONSTANCE.GRAPH_FONT_COLOR,
              fontFamily: CONSTANCE.FONT_FAMILY,
            },
            // backgroundColor:'transparent',
            orient: "horizontal",
            left: "30%",
            top: "90%",
            right: "30%",
            bottom: "0%",
          },
        ],
        series: series,
      };
      this.mychart.setOption(option);
    },
    // 获取事件
     getData() {
        const param = {
        "domain_id": 1,
        "info_category_id": 1,
        "statistic_kind": 2,
        "region_id": 0,
        "event_id": 0,
        "if_total": false
      }
        const params = {
       name:"时间统计分析"
      }
      api.region_information.summarize(param,{params}).response.then((res)=>res.data).then((res) =>{
        if (res.code == 200){
          this.tableData = res.data
          this.updateData();
        }
      })
      
    },
  },
};
</script>

<style scoped>
.lines {
  width: 100%;
  height: 100%;
}
</style>